import angular from "angular";

import "oclazyload";
import ServiceProviderRootModule from "./modules/root/service-provider-root.module";
import ServiceProviderVerificationModule from "./modules/verification/service-provider-verification.module";
import ServiceProviderProfileModule from "./modules/profile/service-provider-profile.module";
import ServiceProviderServicesModule from "./modules/services/service-provider-services.module";
import ServiceProviderSettingsModule from "./modules/settings/service-provider-settings.module";
import ServiceProviderApplicationsModule from "./modules/settings/applications/service-provider-applications.module";
import ServiceProviderPayoutModule from "./modules/payout/service-provider-payout.module";
import ServiceProviderRequestsModule from "./modules/requests/service-provider-requests.module";
import ServiceProviderNotificationsModule from "./modules/notifications/service-provider-notifications.module";

export default angular
  .module("vt-service-provider.module", [
    ServiceProviderRootModule.name,
    ServiceProviderVerificationModule.name,
    ServiceProviderProfileModule.name,
    ServiceProviderServicesModule.name,
    ServiceProviderSettingsModule.name,
    ServiceProviderPayoutModule.name,
    ServiceProviderRequestsModule.name,
    ServiceProviderApplicationsModule.name,
    ServiceProviderPayoutModule.name,
    ServiceProviderNotificationsModule.name
  ]);
